<template>
  <slot
    name="activator"
    v-bind="{ dialog, open, close }"
  ></slot>

  <v-dialog
    v-model="dialog"
    :fullscreen="mobile"
    :max-width="mobile ? '' : maxWidth"
    :min-width="mobile ? '' : minWidth"
    :close-on-content-click="closeOnClick"
  >
    <v-card
      tile
      flat
      :class="[!mobile && 'cc-panel-clip', closeOnClick && 'hoverClose']"
      style="position: relative"
      border="sm"
      :ripple="false"
    >
      <cc-toolbar
        minor
        :title="title"
        :icon="icon"
        :color="color"
        style="position: sticky; top: 0; z-index: 10"
        :hide-close="closeOnClick"
        @close="close"
      >
        <slot name="title" />
        <template #toolbar-items>
          <slot
            name="toolbar-items"
            v-bind="{ close }"
          />
        </template>
      </cc-toolbar>
      <v-card-text :class="noGutters ? 'pa-0' : 'pt-1 pb-4 px-4'">
        <slot v-bind="{ dialog, open, close }" />
      </v-card-text>
      <div v-if="closeOnClick">
        <div class="panel-footer text-center bg-panel">{{ mobile ? 'TAP' : 'CLICK' }} TO CLOSE</div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
  import { useMobile } from '@/mixins/useMobile'
  export default {
    mixins: [useMobile],
    inheritAttrs: false,
    props: {
      title: {
        type: String,
        default: 'Default Title',
      },
      icon: {
        type: String,
      },
      color: {
        type: String,
        default: 'primary',
      },
      closeOnClick: {
        type: Boolean,
        default: true,
      },
      maxWidth: {
        type: [String, Number],
        default: '60vw',
      },
      minWidth: {
        type: [String, Number],
        default: '40vw',
      },
      noGutters: {
        type: Boolean,
        default: false,
      },
      noActions: {
        type: Boolean,
        default: false,
      },
      large: {
        type: Boolean,
        default: false,
      },
      controller: {
        type: Object,
        required: false,
      },
    },
    emits: ['activate'],
    data: () => ({
      dialog: false,
    }),
    methods: {
      open() {
        this.dialog = true
      },
      close() {
        this.dialog = false
      },
    },
  }
</script>

<style scoped>
  .cc-panel-clip {
    clip-path: polygon(0% 0%, 100% 0%, 100% calc(100% - 24px), calc(100% - 24px) 100%, 0% 100%);
  }

  .panel-footer {
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    z-index: 10;
    height: 13px;
    letter-spacing: 4px;
    font-size: 8px;
    line-height: 15px;
    opacity: 0.6;
  }

  .hoverClose:hover {
    cursor: pointer;
    background-color: rgb(var(--v-theme-surface-hover));
  }

  .hoverClose {
    transition: background-color 0.3s ease-in-out;
  }
</style>
